import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { handleLocationChange } from 'app/shared/pageSystem/routing';

const RouteChangeListener: React.FC = () => {
    const location = useLocation();
    const lastLocationKey = React.useRef<string | null>(null);

    React.useEffect(() => {
        const key = `${location.pathname}${location.search}`;
        if (lastLocationKey.current === key) {
            return;
        }
        lastLocationKey.current = key;
        handleLocationChange(location.pathname, location.search);
    }, [location.pathname, location.search]);

    return null;
};

export default RouteChangeListener;